<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>
    <div class="row justify-content-around">
      <div class="map-container mt-5">
        <app-custom-map [center]="[markers[1].location.lng, markers[1].location.lat]" [markerUrl]="markerUrl" [userMarkerUrl]="userMarkerUrl"
          [userMarkerCenter]="[markers[0].location.lng, markers[0].location.lat]" [disabled]="true" [popup]="true">
        </app-custom-map>

      </div>
    </div>
  </div>




</div>